import React, { useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { pendingExamList } from "../../Redux/Slices/UserPackage/PendingExamListSlice";
import { useNavigate } from "react-router-dom";
import styles from "../Mockexampage/MockGrid.module.scss";
import Mockexamimage from "./ImageExamProgresspage/Examprogress1.svg";
import "./ExamProgress.scss";
import { clearListuser, listUser } from "../../Redux/Slices/User/ListUserSlice";
import Menus from "../../Components/Menu/Menu";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import IconButtonField from "../../Components/Button/IconButtonField";
import Avatars from "../../Components/Avatar/Avatars";
import { clearDashboardChart } from "../../Redux/Slices/DashboardChart/DashboardChart";
import UserProfileSection from "../../Components/UserProfileSection/UserProfileSection";
const ExamProgressGrid = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  // Accept an array of 'exams'
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { data: pendingExamLists } = useAppSelector(
    (state) => state.PendingExamList
  );
  const Pending: any = Array.isArray(pendingExamLists?.data)
    ? pendingExamLists?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];

  useEffect(() => {
    dispatch(pendingExamList());
  }, []);

  useEffect(() => {
    dispatch(listUser());
  }, [dispatch]);
  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );
  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];
  return (
    <div className="ExamprocessStudentAlingment">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <div>
          <div className="DashboardStudent">Exam Progress</div>
          <div className={styles.StudentPractice}>
            Track your current exam sessions
          </div>
        </div>
        <div>
          <UserProfileSection />
        </div>
      </div>
      <Grid container spacing={3}>
        {Pending?.length > 0 ? (
          Pending?.map((exam: any, index: any) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <Card className={styles.card} sx={{ boxShadow: "none" }}>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    height: "175px",
                  }}
                >
                  <img
                    src={Mockexamimage}
                    alt="Mock Exam"
                    style={{
                      width: "auto",
                      height: "97%",
                      borderRadius: "10px 10px 0px 0px",
                    }}
                  />
                  {/* <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      background: "black",
                      color: "white",
                      padding: "5px 10px",
                      borderRadius: "15px",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <span>Q</span> 
                    <span>{exam?.total_questions} </span>
                  </div> */}
                </div>

                <CardContent className={styles.cardBody}>
                  <div className={styles.mockexamname}>
                    {exam.gate_exam === false ? "UCAT Exam" : exam.exam_name}
                  </div>
                  <div
                    style={{
                      color: "#6b7280",
                      borderRadius: "20px",
                      fontSize: "14px",
                      padding: "5px",
                    }}
                    title={`Question count : ${exam?.total_questions}`}
                  >
                    <span>Q: {exam?.total_questions}</span>
                    <span style={{ marginLeft: "14px" }}>
                      Completed: {exam.answered_percentage}%
                    </span>
                  </div>
                  <Typography
                    variant="body2"
                    className={styles.mockexamndescription}
                  >
                    {exam.exam_description}
                  </Typography>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      variant="contained"
                      className={styles.startButton}
                      onClick={() => {
                        console.log('ExamProgressPage: Before navigation - exam:', exam);
                        console.log('ExamProgressPage: Current sessionStorage before navigation:', {
                          ucat_exam_mode: sessionStorage.getItem('ucat_exam_mode'),
                          exam_mode: sessionStorage.getItem('exam_mode')
                        });

                        if (exam?.gate_exam === false) {
                          // Set pending mode in sessionStorage before navigation for UCAT exams
                          sessionStorage.setItem("ucat_exam_mode", "pending");
                          sessionStorage.setItem("exam_mode", "pending");
                          sessionStorage.setItem("resume_exam", "true");

                          console.log('ExamProgressPage: Setting sessionStorage for UCAT exam:', {
                            ucat_exam_mode: sessionStorage.getItem('ucat_exam_mode'),
                            exam_mode: sessionStorage.getItem('exam_mode'),
                            resume_exam: sessionStorage.getItem('resume_exam')
                          });

                          // Add a small delay to ensure values are set before navigation
                          setTimeout(() => {
                            console.log('ExamProgressPage: Before UCAT exam navigation - sessionStorage check:', {
                              ucat_exam_mode: sessionStorage.getItem('ucat_exam_mode'),
                              exam_mode: sessionStorage.getItem('exam_mode'),
                              resume_exam: sessionStorage.getItem('resume_exam')
                            });

                            navigate("/ucat_exam_general_instruction", {
                              state: {
                                exam_id: exam?.exam_id,
                                student_exam_id: exam?.id,
                                examMode: 'pending',
                                isResume: true,
                                client_tz_offset: -new Date().getTimezoneOffset()
                              },
                            });
                          }, 100);
                        } else {
                          // Set pending mode in sessionStorage before navigation
                          sessionStorage.setItem("ucat_exam_mode", "pending");
                          sessionStorage.setItem("exam_mode", "pending");
                          sessionStorage.setItem("resume_exam", "true");

                          console.log('ExamProgressPage: After setting sessionStorage:', {
                            ucat_exam_mode: sessionStorage.getItem('ucat_exam_mode'),
                            exam_mode: sessionStorage.getItem('exam_mode'),
                            resume_exam: sessionStorage.getItem('resume_exam')
                          });

                          // Add a small delay to ensure values are set before navigation
                          setTimeout(() => {
                            console.log('ExamProgressPage: Before navigation - sessionStorage check:', {
                              ucat_exam_mode: sessionStorage.getItem('ucat_exam_mode'),
                              exam_mode: sessionStorage.getItem('exam_mode'),
                              resume_exam: sessionStorage.getItem('resume_exam')
                            });

                            navigate("/instructionpending", {
                              state: {
                                exam_id: exam?.exam_id,
                                student_exam_id: exam?.id,
                                examMode: 'pending',
                                isResume: true,
                                client_tz_offset: -new Date().getTimezoneOffset()
                              },
                            });
                          }, 100);
                        }
                      }}
                    >
                      Continue
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid container justifyContent="center" sx={{ marginTop: "20px" }}>
            <Card
              sx={{
                maxWidth: 650,
                borderRadius: "15px",
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                overflow: "hidden",
                marginLeft: "20px",
              }}
            >
              <img
                src={Mockexamimage}
                alt="No Exam"
                style={{
                  width: "100%",
                  height: "220px",
                  objectFit: "cover",
                  borderTopLeftRadius: "15px",
                  borderTopRightRadius: "15px",
                }}
              />

              <CardContent>
                <Typography
                  fontSize="20px"
                  align="center"
                  fontWeight="bold"
                  marginBottom={"8px"}
                >
                  No pending exam available
                </Typography>

                <Typography
                  variant="body2"
                  style={{
                    textAlign: "center",
                    marginTop: "12px",
                    fontSize: "16px",
                  }}
                  className="mockexamndescription"
                >
                  Currently, there are no pending exams available at the moment.
                </Typography>
                <Grid container justifyContent="center" mt={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    className="startSButton"
                    onClick={() => navigate("/dashboard")}
                  >
                    Back To Home
                  </Button>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default ExamProgressGrid;
